import styled from 'styled-components';
import { Icon as AntdIcon } from 'antd';

export const ConfigLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.element.primary};
  margin-bottom: 0;
`;

export const LabelAlert = styled.div`
  background-color: ${({ theme, status }) => {
    switch (status) {
      case 'warning':
        return theme.colors.alert.secondary;
      case 'error':
        return theme.colors.negative.secondary;
      case 'neutral':
        return theme.colors.background.tertiary;
      case 'info':
        return theme.colors.info.secondary;
      default:
        return theme.colors.positive.secondary;
    }
  }};
  border-radius: 16px;
  min-width: 300px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  width: ${({ width, fullWidth }) => (fullWidth ? '100%' : width || 'auto')};
`;

export const Icon = styled(AntdIcon)`
  color: ${({ theme, status }) => {
    switch (status) {
      case 'warning':
        return theme.colors.alert.primaryAlt;
      case 'error':
        return theme.colors.negative.primaryAlt;
      case 'neutral':
        return theme.colors.element.secondary;
      case 'info':
        return theme.colors.info.primaryAlt;
      default:
        return theme.colors.positive.primaryAlt;
    }
  }};
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;

  svg {
    width: 18px;
    height: 18px;
  }
`;
